AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "EdgeSection");

AoPS.Ebooks.Models.EdgeSection = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var EbkMBase = AoPS.Ebooks.Models.Base;
	var EbkMBaseSection = AoPS.Ebooks.Models.BaseSection;

	return EbkMBaseSection.extend({
		// See EbkModels.BaseSection for basic attributes
		// Note the ID field is the fragment code; edge sections may not have numeric IDs
		/** Additional attributes:
			book: Book model; guaranteed to be set
		*/

		initialize: function () {
			this.set("edge", true);
		},

		requestLoad: function (callback, context) {
			if (!this.section_loader) {
				this.section_loader = new LoadUtils.LoadManager({
					loadHandler: this.loadContent,
					context: this,
				});
			}
			callback = LoadUtils.makeCallback(callback, context);

			this.get("book").requestLoad(function (ok, data) {
				if (!ok) {
					return callback(ok, data);
				}
				this.section_loader.requestLoad(callback);
			}, this);
		},

		reload: function (callback, context) {
			if (this.section_loader) {
				this.section_loader.forceReload();
			}
			this.requestLoad(callback, context);
		},

		loadContent: function (callback) {
			var book = this.get("book");
			EbkMBase.ajax.run(
				"load_edge_section",
				{
					user_id: book.get("master").get("user_id"),
					book_id: book.id,
					section_code: this.get("fragment_code") || this.id,
				},
				function (ok, data) {
					if (!ok) {
						book.get("edge_sections").remove(this.id);
						return callback(ok, data);
					}
					book.unpack(data.response.book);
					callback(ok, {});
				}
			);
		},

		getNumberTitle: function (full) {
			return (
				(this.get("fragment_code") || this.id) + " " + this.get("title_html")
			);
		},
	});
})();
